import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export type TruckAction = 'resubmit' | 'update';

@Component({
  selector: 'app-truck-action-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule],
  templateUrl: './truck-action-dialog.component.html',
  styleUrls: ['./truck-action-dialog.component.scss']
})
export class TruckActionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TruckActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { order: any }
  ) {}

  select(action: TruckAction): void {
    this.dialogRef.close(action);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
